import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { POSTS } from "@/data/posts";

export default function JournalPage() {
  return (
    <>
      <Seo
        title="Journal — SAIVU | Practical reads on GST, income tax & startups"
        description="Sharp, practical reads from the SAIVU team on GST registration, choosing a tax regime, DPIIT recognition and running a compliant business in India."
        path="/journal"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "SAIVU Journal",
          url: "https://saivu.in/journal",
        }}
      />
      <section className="bg-mist pt-28 pb-14 sm:pt-32" data-testid="journal-hero">
        <div className="mx-auto max-w-7xl px-5 sm:px-6">
          <Reveal>
            <p className="font-mono text-xs font-medium uppercase tracking-[0.18em] text-gold-deep sm:text-sm">The Journal</p>
            <h1 className="mt-5 max-w-3xl text-4xl font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-5xl">
              Sharp reads for founders & finance leaders.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink sm:text-lg">
              Plain-language guides on the filings, deadlines and decisions that move a
              business — written by the team that handles them daily.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white pb-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-6">
          {POSTS.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.05}>
              <Link
                to={`/journal/${post.slug}`}
                data-testid={`journal-post-${post.slug}`}
                className="group grid grid-cols-12 items-center gap-4 border-b border-line px-2 py-9 transition-colors last:border-t hover:bg-mist sm:px-4"
              >
                <span className="col-span-2 font-mono text-sm font-medium text-slate-600 sm:col-span-1">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="col-span-9 sm:col-span-8">
                  <span className="mb-2 inline-block font-mono text-[11px] font-medium uppercase tracking-[0.14em] text-gold-deep">
                    {post.category} · {post.date} · {post.readTime}
                  </span>
                  <span className="block text-xl font-semibold text-navy-900 sm:text-2xl">
                    {post.title}
                  </span>
                  <span className="mt-2 block text-sm leading-relaxed text-ink sm:text-[15px]">
                    {post.excerpt}
                  </span>
                </span>
                <span className="col-span-1 flex justify-end">
                  <ArrowUpRight className="h-5 w-5 text-slate-600 transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-navy-900" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
